import Vue from 'vue'
import Unicon from 'vue-unicons'
import {
  uniMessage, uniCog, uniAtmCard, uniUsersAlt, uniShoppingCartAlt,
  uniClipboardNotes, uniPricetagAlt, uniQuestionCircle, uniImageShare,
  uniListUl, uniBox, uniGlobe, uniPolygon, uniCheckCircle, uniLocationPoint,
  uniObjectGroup, uniUser, uniLock, uniEye, uniSearch, uniTimesCircle,
  uniAlignLeft, uniTimes
} from 'vue-unicons/src/icons'

Unicon.add([
  uniMessage, uniCog, uniAtmCard, uniUsersAlt, uniShoppingCartAlt,
  uniClipboardNotes, uniPricetagAlt, uniQuestionCircle, uniImageShare,
  uniListUl, uniBox, uniGlobe, uniPolygon, uniCheckCircle, uniLocationPoint,
  uniObjectGroup, uniUser, uniLock, uniEye, uniSearch, uniTimesCircle,
  uniAlignLeft, uniTimes
])

Vue.use(Unicon)



// WEBPACK FOOTER //
// ./src/plugin/vue-unicons.js